























































import { defineComponent, toRefs, PropType, computed, watch, onMounted } from '@vue/composition-api';
import {
  AdgroupFormData,
  FullNormalFormData,
  PRODUCT_SPECIFIC_TYPE,
  CreativeConfig,
  CampaignFormData,
  ACTION_TYPE,
  PRODUCTS_PSA_MAX_NUM,
} from '@tt4b/ttam-enums';
import ProductDetails from './index';
import { useProductDetailValidate, useCreativeActionTypeIs } from '@tt4b/ttam-hooks';

const name = 'ttam-product-details-psa-compose';
export default defineComponent({
  name,
  components: {
    TtamProductDetailsSource: ProductDetails.TtamProductDetailsSource,
    TtamProductDetailsDesc: ProductDetails.TtamProductDetailsDesc,
    TtamProductDetailsSpecificType: ProductDetails.TtamProductDetailsSpecificType,
    TtamProductDetailsProductList: ProductDetails.TtamProductDetailsProductsList,
    TtamProductDetailsProductsListActions: ProductDetails.TtamProductDetailsProductsListActions,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData>,
      required: true,
      default: () => ({} as FullNormalFormData),
    },
    creativeConfig: {
      type: Object as PropType<CreativeConfig>,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String,
      default: ACTION_TYPE.CREATE,
    },
  },
  setup(props, { emit, refs }) {
    const { adgroupData, creativeData, campaignData, createMode } = toRefs(props);
    const shopInfo = ProductDetails.useShopInfo({ adgroupData });

    const { isEdit, isCopy } = useCreativeActionTypeIs({ createMode, adgroupFormData: adgroupData });

    const isShowProductSelect = computed(
      () => creativeData.value.productSpecificType === PRODUCT_SPECIFIC_TYPE.PRODUCTS,
    );

    const onSpecificTypeChange = val => {
      emit('products-detail-specific-type-change', val);
    };

    // 可以复用shop的hook
    const { productListDataSource, onProductListChange } = ProductDetails.useProductListForShop({
      creativeData,
      emit,
    });

    const { openDrawer, clear } = ProductDetails.useListActions(emit);

    const { spuListValidator, spuTypeValidator } = useProductDetailValidate({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });

    onMounted(() => {
      if (isCopy.value) {
        // copy的时候进页面就需要校验一下
        refs.spuListFormItem?.validate?.('change');
        refs.spuTypeSelectFormItem?.validate?.('change');
      }
    });

    watch([() => creativeData.value.productSpecificType], () => {
      refs.spuListFormItem?.clearValidate();
    });
    watch(
      () => creativeData.value.spuList?.length,
      () => {
        refs.spuListFormItem?.validate('change');
      },
    );

    return {
      name,
      isEdit,
      onSpecificTypeChange,
      isShowProductSelect,
      productListDataSource,
      onProductListChange,
      openDrawer,
      clear,
      spuListValidator,
      spuTypeValidator,
      PRODUCTS_PSA_MAX_NUM,
      shopInfo,
    };
  },
});
